import { GameComponent } from '../GameComponent';
import { GameComponentFastaily } from './GameComponentFastaily';
import { GameComponentClassic} from "./GameComponentClassic";
import {GameModes} from "../../../constants/EnumGameModes";
import {GameComponentRace} from "./GameComponentRace";

export function getGameComponent(gameMode: GameModes, finishGame: () => void): GameComponent {
    switch (gameMode) {
        case GameModes.CLASSIC_SOLO:
            return new GameComponentClassic(finishGame);
        case GameModes.FASTAILY:
            return new GameComponentFastaily(finishGame);
        case GameModes.RACE_SOLO:
            return new GameComponentRace(finishGame);
        default:
            throw new Error(`Unsupported game mode: ${gameMode}`);
    }
}